import { render, staticRenderFns } from "./ViewEvaluation.vue?vue&type=template&id=4fbb5738&"
import script from "./ViewEvaluation.vue?vue&type=script&lang=js&"
export * from "./ViewEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./ViewEvaluation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports